import React from 'react';

import { flagStyles } from '../settings';

const SvgWF = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5736px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgWF;
